/**
 * @deprecated If using for form validation please use `FieldNumeric`
 * and `FieldNumericControlled` instead.
 */
export const positiveDecimalNumbersRegEx = new RegExp('^[+]?[0-9]{0,900}(?:\\.[0-9]{0,900})?$');
